import { isBefore, now } from 'owa-datetime';
import isDateInDateRangeUsingMinutes from './isDateInDateRangeUsingMinutes';
import type { DateRange } from 'owa-datetime-utils';

/**
 * Returns the appropriate PastPresentFutureType enum based on the time an event's peek is viewed.
 */
export default function getTimeAsPastPresentFutureType(
    dateRange: DateRange
): PastPresentFutureType {
    if (dateRange?.start) {
        const currentTime = now();

        if (isDateInDateRangeUsingMinutes(dateRange, currentTime)) {
            return PastPresentFutureType.present;
        } else if (isBefore(currentTime, dateRange.start)) {
            return PastPresentFutureType.future;
        } else {
            return PastPresentFutureType.past;
        }
    }

    return null;
}

/**
 * PastPresentFutureType
 */
export const enum PastPresentFutureType {
    past,
    present,
    future,
}
